import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'

import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import FlightSearchAirportSelect from './FlightAirportSelect/FlightSearchAirportSelect'
import { rem } from 'polished'
import SearchFormFieldGroup from 'components/SearchV2/Components/SearchFormField/SearchFormFieldGroup'
import Clickable from 'components/Common/Clickable'
import LineExchangeAltIcon from 'components/Luxkit/Icons/line/LineExchangeAltIcon'

const InputContainer = styled(SearchFormFieldGroup)`
  display: grid;
  grid-template-columns: 1fr ${rem(50)} 1fr;
`

const ExchangeButton = styled(Clickable)`
  border-top: 1px solid ${props => props.theme.palette.neutral.five};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.five};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${rem(50)};
  height: ${rem(50)};
`

interface Props {
  className?: string
}

function FlightSearchAirportInputs(props: Props) {
  const { className } = props
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const {
    departureAirport,
    arrivalAirport,
  } = state

  const onSwapAirports = useCallback(() => {
    const departure = departureAirport
    dispatch({ type: FlightSearchWidgetActions.SET_DEPARTURE_AIRPORT, airport: arrivalAirport })
    dispatch({ type: FlightSearchWidgetActions.SET_ARRIVAL_AIRPORT, airport: departure })
  }, [departureAirport, dispatch, arrivalAirport])

  return (
    <InputContainer className={className}>
      <FlightSearchAirportSelect
        isDeparture
        title="From"
        required
      />
      <ExchangeButton onClick={onSwapAirports}>
        <LineExchangeAltIcon size="M" />
      </ExchangeButton>
      <FlightSearchAirportSelect
        title="To"
        required
      />
    </InputContainer>
  )
}

export default FlightSearchAirportInputs
